import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import i18n from '../../i18n';
import TableBody from '@material-ui/core/TableBody';
import Icon from '@material-ui/core/Icon';
import React, {useState} from 'react';
import {useQuery} from '@apollo/react-hooks';
import costCenterQueries from "../../queries/costCenterQueries";
import {TableFooter, Typography, withStyles} from '@material-ui/core';
import Query from 'react-apollo/Query';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import FormField from '../Form/FormField';
import IconButton from '@material-ui/core/IconButton';
import costCenterMutations from '../../mutations/costCenterMutations';
import {getMutationName} from '../Form/utils';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import CostCenterEdit from "../CostCenter/CostCenterEdit";
import configQueries from "../../queries/configQueries";
import SymbolEdit from "./SymbolEdit";
import _ from "lodash";

const SymbolsList = (props) => {

    const {classes} = props;

    const [adds, setAdds] = useState({data: []});
    const [canAdd, setCanAdd] = useState(true);
    const [reloading,setReloading] = useState(false);

    const unmount = (values) => {
        let toUnsetId = _.findIndex(adds.data,{
            id: values?.id || null ,
            acronym: values?.acronym || '',
            name: values?.name || '',
        });
        _.unset(adds.data,toUnsetId);
        let result = _.filter(adds.data, _.size);
        setAdds({data: result})
    }

    return (

        <Grid container spacing={0}>
            {/*<Typography variant="h6" color={"primary"}>*/}
            {/*    {i18n.get('config.work_time.symbols')}*/}
            {/*</Typography>*/}
            <Grid item xs={12} >
                <Table className={classes.list}>
                    <TableHead>
                        <TableRow>
                            <TableCell scope="col">{i18n.get('config.work_time.symbol')}</TableCell>
                            <TableCell scope="col">{i18n.get('config.work_time.name')}</TableCell>
                            <TableCell scope="col">{i18n.get('config.work_time.record_work_time')}</TableCell>
                            <TableCell scope="col">{i18n.get('config.work_time.actions')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <Query query={configQueries.allSymbols} >
                            {({loading, error, data, refetch}) => {
                                if (loading) {
                                    return <TableRow><TableCell colSpan={4}><GraphQlLoading/></TableCell></TableRow>;
                                }
                                if (error) {
                                    return <TableRow><TableCell colSpan={4}><GraphQlError/></TableCell></TableRow>;
                                }
                                if(reloading) {
                                    refetch();
                                    // _.unset(data.worktimesymbols.data,0);
                                    // data.worktimesymbols.data = _.filter(data.worktimesymbols.data, _.size);
                                    // console.log('remove from',data.worktimesymbols.data);
                                }
                                return data.worktimesymbols.data && data.worktimesymbols.data.length > 0 &&
                                    data.worktimesymbols.data.map((wts, idx) => (
                                        <SymbolEdit
                                            key={`symbol_${idx}`}
                                            values={wts}
                                            setCanAdd={setCanAdd}
                                            unmount={unmount}
                                            setReloading={setReloading}
                                            onSubmit={(wts) => {
                                                //handleSubmit(wts);
                                            }}
                                        />
                                    ));
                            }}
                        </Query>
                        {adds && adds.data && adds.data.length > 0 && adds.data.map((wts, idx) => (
                            <SymbolEdit
                                key={`symbol_${idx}`}
                                values={wts}
                                setCanAdd={setCanAdd}
                                edit={true}
                                unmount={unmount}
                                setReloading={setReloading}
                                onSubmit={(wts) => {
                                    //handleSubmit(wts);
                                }}
                            />
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            {canAdd &&
                <Grid item xs={12} style={{textAlign:'right'}}>
                    <Button
                        component={'a'}
                        variant={'contained'}
                        size={'small'}
                        color={'primary'}
                        onClick={() => {
                            adds.data.push({id: null, acronym: '' , name: '', record: false} );
                            setAdds({data: adds.data});
                            setCanAdd(false);
                        }}
                        className={props.classes.spacing}
                    >
                        <Icon>add</Icon>
                        &nbsp;
                        {i18n.get('config.work_time.add_symbol')}
                    </Button>

                </Grid>
            }
        </Grid>
    );
};

const styles = theme => ({
    spacing: {
        marginTop: theme.spacing.unit * 2
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    list: {

        "& tr": {
            height:40,
        },
        "& th": {
            textAlign: 'center',
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
            textAlign: 'center',
        },
        "& label": {
            margin:0,
        },
        "& p": {
            margin:0,
            padding:0,
            minHeight:0,
        },
        "& span": {
            padding:0,
        },
        "& a": {
            padding:2,
        }
    },
});

export default withStyles(styles)(SymbolsList);
